import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { AppRouting } from '@core/enums';
import { Store } from '@ngrx/store';
import { generalFeature } from '@src/state/general';
import { filter, map, take } from 'rxjs';

export const dataOnlyGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(generalFeature.selectIsDataOnly).pipe(
    filter((v) => v !== null),
    take(1),
    map((isDataOnly) =>
      isDataOnly ? new RedirectCommand(router.parseUrl(`/${AppRouting.Overview}`)) : true
    )
  );
};
